import { createContext, useContext } from 'react';

export const ChatModalContext = createContext({ openChat: () => {} });

export const useChatModal = () => useContext(ChatModalContext);
